import {actions, ISpinner} from "../reducers/actionSpinner";

export const setSpinner = (key: string) => {
    return {type: actions.SET_ACTION_SPINNER, payload: key}
};

export const deleteSpinner = (key: string) => {
    return {type: actions.DELETE_ACTION_SPINNER, payload: key}
};

export const updateSpinner = (key: string, spinner: ISpinner) => {
    return {type: actions.UPDATE_ACTION_SPINNER, payload: {key, spinner}}
};

export const resetState = () => {
    return {type: actions.RESET_ACTION_SPINNER_STATE}
};


// WEBPACK FOOTER //
// ./app/actions/actionSpinnerActions.ts